// The Contact Us form sends one row to `fusion_inquiries` (POST /license/inquiries).
// The columns are name varchar(45), phone varchar(45), email varchar(45) and notes varchar(512).
// MySQL runs in strict mode, so a value over its column length fails the whole insert.
// The organization, the reason and the optional notes are packed into the one notes column.

const ORGANIZATION_LABEL = 'Organization Name: ';
const REASON_LABEL = 'Reason for Inquiry: ';
const NOTES_LABEL = 'Notes: ';
const LINE_SEPARATOR = '\n';

export const INQUIRY_NOTES_COLUMN_MAX_LENGTH = 512;

const PACKED_NOTES_OVERHEAD =
  ORGANIZATION_LABEL.length + REASON_LABEL.length + NOTES_LABEL.length + LINE_SEPARATOR.length * 2;

const ORGANIZATION_MAX_LENGTH = 100;
const REASON_MAX_LENGTH = 100;

export const CONTACT_INQUIRY_MAX_LENGTHS = {
  name: 45,
  email: 45,
  phone: 45,
  organizationName: ORGANIZATION_MAX_LENGTH,
  reason: REASON_MAX_LENGTH,
  notes:
    INQUIRY_NOTES_COLUMN_MAX_LENGTH -
    PACKED_NOTES_OVERHEAD -
    ORGANIZATION_MAX_LENGTH -
    REASON_MAX_LENGTH,
} as const;

export type ContactInquiryNotesFields = {
  organizationName: string;
  reason: string;
  notes: string;
};

export function getPackedInquiryNotes({
  organizationName,
  reason,
  notes,
}: ContactInquiryNotesFields): string {
  const trimmedNotes = notes.trim();
  return [
    `${ORGANIZATION_LABEL}${organizationName.trim()}`,
    `${REASON_LABEL}${reason.trim()}`,
    ...(trimmedNotes ? [`${NOTES_LABEL}${trimmedNotes}`] : []),
  ].join(LINE_SEPARATOR);
}
